import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTools = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_796_22632)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M9.75 11.9004C9.15044 10.8154 8.90167 9.57134 9.0379 8.3392C9.17412 7.10706 9.68865 5.94736 10.5107 5.01952C11.3328 4.09168 12.4221 3.44126 13.6289 3.15766C14.8357 2.87406 16.1007 2.97121 17.25 3.43576L13.5 7.49982L14.0306 9.96919L16.5 10.4998L20.5641 6.74982C21.0286 7.89913 21.1258 9.16412 20.8422 10.3709C20.5586 11.5777 19.9081 12.667 18.9803 13.4891C18.0525 14.3112 16.8928 14.8257 15.6606 14.9619C14.4285 15.0981 13.1844 14.8494 12.0994 14.2498L6.84375 20.3436C6.42106 20.7663 5.84777 21.0037 5.25 21.0037C4.65222 21.0037 4.07894 20.7663 3.65625 20.3436C3.23356 19.9209 2.99609 19.3476 2.99609 18.7498C2.99609 18.152 3.23356 17.5788 3.65625 17.1561L9.75 11.9004Z",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_796_22632",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export { SvgTools as ReactComponent };
